import request from '@/utils/request'

// 获取活动详情
export function GetActivity(data) {
    data = JSON.stringify(data)
    return request({
      url: "api/activity/getactivity",
      method: "post",
      headers: {
        'Content-Type': 'application/json'
      },
      data
    });
}

// 领取优惠券
export function GetCoupon(data,token) {
    data = JSON.stringify(data)
    return request({
        url: "api/coupon/getcoupon",
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token
        },
        data
    })
}

// 添加受邀用
export function addInvitedUser(data) {
  return request({
    url: "api/InvitationCard/AddInvitedUser",
    method: "POST",
    data
  })
}

export function GetIsShowMore(params) {
  return request({
    url: "api/InvitationCard/GetIsShowMore",
    method: "GET",
    params
  })
}


// 添加用户反馈
export function addFeedback(data) {
  return request({
    url: "/api/MusicLibrary/AddFeedback",
    method: "POST",
    data
  })
}